import { FormattedDate, FormattedMessage, MessageDescriptor } from "react-intl";

import Heading from "@atlaskit/heading";
import { Stack, Text, Inline, xcss, Flex } from "@atlaskit/primitives-next";

import { WelcomeBannerImage } from "../../assets/welcome-banner-image";

import { messages } from "./messages";

const headerContainerStyles = xcss({
    borderRadius: "border.radius.200",
    backgroundColor: "color.background.selected"
});

const contentContainerStyles = xcss({
    padding: "space.200",
    flex: 1
});

const cloudIconContainerStyles = xcss({
    width: "350px"
});

export type BaseWelcomeBannerProps = {
    // Currently we can't mock the date in the storybook, which means snapshots taken will fail
    // this means we need to pass the current time to the component
    currentTime: number;
    userName?: string;
    subtitleMessage: MessageDescriptor;
};

export const BaseWelcomeBanner = ({
    currentTime,
    userName,
    subtitleMessage
}: BaseWelcomeBannerProps) => {
    return (
        <Flex xcss={headerContainerStyles} alignItems="center">
            <Stack space="space.250" xcss={contentContainerStyles}>
                <Stack>
                    <Text>
                        <FormattedDate
                            weekday="long"
                            day="numeric"
                            month="long"
                            value={currentTime}
                        />
                    </Text>
                    <Heading size="medium" as="h1">
                        {userName ? (
                            <FormattedMessage
                                {...messages.bannerTitleWithName}
                                values={{ name: userName }}
                            />
                        ) : (
                            <FormattedMessage
                                {...messages.bannerTitleWithoutName}
                            />
                        )}
                    </Heading>
                </Stack>
                <Inline>
                    <Text>
                        <FormattedMessage {...subtitleMessage} />
                    </Text>
                </Inline>
            </Stack>
            <Flex
                xcss={cloudIconContainerStyles}
                justifyContent="end"
                alignItems="center"
            >
                <WelcomeBannerImage />
            </Flex>
        </Flex>
    );
};
